var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiSop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.172 11.172C11 12.343 11 14.229 11 18V22C11 25.771 11 27.657 12.172 28.828C13.344 29.999 15.229 30 19 30H21C24.771 30 26.657 30 27.828 28.828C28.999 27.656 29 25.771 29 22V18C29 14.229 29 12.343 27.828 11.172C26.656 10.001 24.771 10 21 10H19C15.229 10 13.343 10 12.172 11.172ZM16 17.25C15.8011 17.25 15.6103 17.329 15.4697 17.4697C15.329 17.6103 15.25 17.8011 15.25 18C15.25 18.1989 15.329 18.3897 15.4697 18.5303C15.6103 18.671 15.8011 18.75 16 18.75H24C24.1989 18.75 24.3897 18.671 24.5303 18.5303C24.671 18.3897 24.75 18.1989 24.75 18C24.75 17.8011 24.671 17.6103 24.5303 17.4697C24.3897 17.329 24.1989 17.25 24 17.25H16ZM16 21.25C15.8011 21.25 15.6103 21.329 15.4697 21.4697C15.329 21.6103 15.25 21.8011 15.25 22C15.25 22.1989 15.329 22.3897 15.4697 22.5303C15.6103 22.671 15.8011 22.75 16 22.75H21C21.1989 22.75 21.3897 22.671 21.5303 22.5303C21.671 22.3897 21.75 22.1989 21.75 22C21.75 21.8011 21.671 21.6103 21.5303 21.4697C21.3897 21.329 21.1989 21.25 21 21.25H16Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSop);
export default __webpack_public_path__ + "static/media/AiSOP.b59d0f4624bec70392ffdd62322f92ff.svg";
export { ForwardRef as ReactComponent };